// extracted by mini-css-extract-plugin
export default {"container":"NoFile_container__I1Zgl"};